import React from "react";

import { NotImplementedField } from "../../formComponents/NotImplementedField";
import type { FormFieldFactoryProps } from "../../types/types";
import { VerticalFormFieldsMap } from "./VerticalFormFieldsMap";
import { VerticalFormFieldWrapper } from "./VerticalFormFieldWrapper";

export const createVerticalFormField = (props: FormFieldFactoryProps) => {
    const field = (
        <VerticalFormFieldWrapper
            field={props}
            formComponent={React.createElement(VerticalFormFieldsMap[props.field.component] || NotImplementedField, {
                ...props,
                className: "aevi-form-field-vertical",
            })}
        />
    );
    return React.cloneElement(field, { ...props, className: "aevi-form-field-vertical" });
};
